import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';

export interface Hectometre {
    id: number;
    lat: number;
    lng: number;
    hectometre: number;
    waynumber: string;
    direction?: string | null;
    street: string;
    place: string;
    district: string;
    letter?: string | null;
    poles: any[];
    distance?: number;
    formatted_address?: string;
    road_number?: string;
}

export interface HectometreSeries {
    from: number;
    to: number;
    distance: number;
    poles: Hectometre[];
}

export interface HectometreGroup {
    waynumber: string;
    direction: string | null;
    letter: string | null;
    street: string;
    place: string;
    district: string;
    series: HectometreSeries[];
}

@Injectable({
    providedIn: 'root',
})
export class HectometreService {
    constructor(private apiService: ApiService) {}

    public getHectopins(bounds: google.maps.LatLngBounds, zoom?: number) {
        const sw = bounds.getSouthWest();
        const ne = bounds.getNorthEast();
        const bbox = `${sw.lng()},${sw.lat()},${ne.lng()},${ne.lat()}`;

        return this.apiService.getCall$<Hectometre[]>('hectopins', { bbox, zoom });
    }

    public search(term: string) {
        return this.apiService.postCall$<Hectometre[]>('hectopins/search', { search: term });
    }

    public nearby(lat: number, lng: number) {
        return this.apiService.getCall$<HectometreGroup[]>('hectopins/nearby', { lat, lng });
    }
}
